import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import ContextReminderContainer from '../components/ContextReminderContainer'
import {
  actionCreators,
  IContextReminderState,
  selectReminders,
  selectReminderText,
  selectShowAll,
  selectShowCompleted,
} from '../modules/contextReminder'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IContextReminderState & ICurrentUserState
  >({
    reminderText: selectReminderText(),
    reminders: selectReminders(),
    showAll: selectShowAll(),
    showCompleted: selectShowCompleted(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(ContextReminderContainer)
